// Import Core
import React from 'react';
import styled from 'styled-components';
// Import Icons
import { FaChevronLeft, FaChevronRight, FaCircle } from 'react-icons/fa';

const PaginationStyles = styled.ul`
	padding-top: 40px;
	display: flex;
	width: fit-content;
	gap: 10px;
	list-style-type: none;
	align-items: center;
	@media (max-width: 768px) {
		padding-top: 24px;
		justify-content: center;
		width: 100%;
	}
	li {
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		&.pagination-arrow {
			width: 67px;
			height: 67px;
			background: var(--primary-500);
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			color: var(--white);
			&.prev-arrow {
				margin-right: 30px;
			}
			&.next-arrow {
				margin-left: 30px;
			}
      &.disabled {
        background: var(--neutral-200);
        color: var(--neutral-500);
        cursor: not-allowed;
      }
		}
		&.page-dots {
			width: 18px;
			height: 18px;
			color: var(--neutral-300);
			opacity: 1;
			&.active {
				width: 16px;
				height: 16px;
				color: transparent;
				border-radius: 50%;
				border: 1px solid var(--neutral-300);
			}
		}
	}
`;

const Pagination = ({
	nPages,
	currentPage,
	setCurrentPage,
	// smoothScrollOnClick,
}) => {
	const pageNumbers = [...Array(nPages + 1).keys()].slice(1);

	const nextPage = () => {
		if (currentPage !== nPages) {
      setCurrentPage(currentPage + 1)
      // smoothScrollOnClick()
    }
	};
	const prevPage = () => {
		if (currentPage !== 1) {
      setCurrentPage(currentPage - 1)
      // smoothScrollOnClick()
    }
	};

	return (
		<PaginationStyles>
			<li className={`pagination-arrow prev-arrow${currentPage === 1 ? ' disabled' : ''}`} onClick={prevPage}>
				<FaChevronLeft />
			</li>
			{pageNumbers.map((pgNumber) => (
				<li
					key={pgNumber}
					className={`page-dots ${currentPage == pgNumber ? 'active' : ''} `}
					onClick={() => setCurrentPage(pgNumber)}>
					<FaCircle />
				</li>
			))}
			<li className={`pagination-arrow next-arrow${currentPage === nPages ? ' disabled' : ''}`} onClick={nextPage}>
				<FaChevronRight />
			</li>
		</PaginationStyles>
	);
};

export default Pagination;
